import {Kbd, createStyles} from '@mantine/core';
import React from 'react';

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '8px 16px',
    borderTop: '1px solid #e9ecef',
    backgroundColor: '#f8f9fa',
    flexShrink: 0,
    fontSize: 13,
    color: '#868e96',
  },
  hints: {
    display: 'flex',
    gap: 14,
    alignItems: 'center',
  },
  kbd: {
    fontSize: 13,
  },
}));

interface OmniboxFooterProps {
  hasNavigableResults: boolean;
}

export default function OmniboxFooter({hasNavigableResults}: OmniboxFooterProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.root}>
      {hasNavigableResults && (
        <div className={classes.hints}>
          <span>
            <Kbd className={classes.kbd}>↑</Kbd> <Kbd className={classes.kbd}>↓</Kbd> navigate
          </span>
          <span>
            <Kbd className={classes.kbd}>↵</Kbd> select
          </span>
          <span>
            <Kbd className={classes.kbd}>esc</Kbd> close
          </span>
        </div>
      )}
    </div>
  );
}
